import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { QuoteStatusChangeCondition } from '../form/parts/conditions/quote-condition-change-condition';
import { CheckEntityStatus } from '../form/parts/conditions/check-entity-status';
import { CheckStatusIsConfirmed } from 'src/app/rules/rules/form/parts/conditions/check-quote-is-confirmed';
import { ProductTypeCondition } from 'src/app/rules/rules/form/parts/conditions/product-type.condition';
import { QuoteEntryStatusCondition } from 'src/app/rules/rules/form/parts/conditions/quote-entry-status.condition';
import { QuoteEntryStatusSimpleCondition } from 'src/app/rules/rules/form/parts/conditions/quote-entry-current-status.condition';
import { QuoteEntryModifyCondition } from 'src/app/rules/rules/form/parts/conditions/quote-entry-modify.condition';
import { CheckEntityChangeStatusCName, CheckStatusChangeToConfirmedCName, ProductTypeCheckerCName, QuoteEntryStatusCheckConditionCName, QuoteEntryStatusCheckCName, QuoteEntryModifyingCOnditionCName } from 'src/app/rules/rules/parts/conditions';

interface RulesConditionEditorViewProps {
	onChanged: (event: ConditionDefinitionItem) => void;
	onFieldChange: (propName: string, value: any) => void;
	fieldValues?: any;
	eventClasspath: string;
	event: PublicEventItem;
	wrapperName: string;
	value?: RuleDefinition;
	label: string;
	required?: boolean;
	mode: ControlMode;
	setBusy(isBusy: boolean);
}

@observer
export class RulesConditionEditorView extends React.Component<RulesConditionEditorViewProps, { options: any[], item?: ConditionDefinitionItem }> {
	constructor(props) {
		super(props);

		this.state = {
			options: [],
			item: null
		}
	}

	@resolve
	protected reflectionService: RulesReflectionService;

	public componentWillReceiveProps(nextProps: RulesConditionEditorViewProps) {
		if ((nextProps.eventClasspath != this.props.eventClasspath) || nextProps.value != this.props.value) {
			this.request(nextProps);
		}
	}

	request(props: RulesConditionEditorViewProps) {

		this.reflectionService.getConditionDefinitions(this.props.wrapperName).then(conditions => {
			this.setState({ options: conditions}, () => {

				if (props.value)
					var opt = this.state.options.find((value: ConditionDefinitionItem, index) => value.classPath === props.value.conditionDefinitionType);

				if (opt)
					this.setState({ item: opt });
			});
		});
	}

	public componentDidMount() {
		this.request(this.props);
	}

	@autobind
	protected onEventSelect(item: any) {
		this.setState({ item });
		this.props.onChanged(item);
	}

	@autobind
	protected getEventFields(item: PublicEventItem) {
		return item ? item.properties: [];
	}
	

	private getConditionComponent(name: string) {

		const props = {
			mode: this.props.mode,
			values: this.props.value && this.props.value.conditionValues,
			onFieldChange: this.props.onFieldChange
		};

		switch (name) {
			case CheckEntityChangeStatusCName:
				return <CheckEntityStatus
					{...props}/>;

			case CheckStatusChangeToConfirmedCName:
				return <CheckStatusIsConfirmed
					{...props}
				/>;
			case ProductTypeCheckerCName:
				return <ProductTypeCondition
					{...props} />
			case QuoteEntryStatusCheckConditionCName:
				return <QuoteEntryStatusCondition
					{...props} />
			case QuoteEntryStatusCheckCName:
				return <QuoteEntryStatusSimpleCondition
					{...props}
				/>
			case QuoteEntryModifyingCOnditionCName:
				return <QuoteEntryModifyCondition
					{...props}
				/>
		}

		return null;
	}


	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Condition';
		}

		if (this.state.options.length < 1)
			return null;

		return (
			<React.Fragment>
			<Row>
					<Col xs={24} lg={8}>
						<DropdownView
							label={label}
							model={this.props.value ? this.props.value.conditionDefinitionType : ''}
							required={this.props.required}
							disabled={this.props.mode == 'display'}
							onChanged={this.onEventSelect}
							options={this.state.options}
							keyField='classPath'
							textField='name'
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={24} lg={24} style={{marginTop: '10px'}} >
						{this.state.item && this.getConditionComponent(this.state.item.classPath)}
					</Col>
				</Row>
				</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/parts/rules-conditions.editor.tsx